import { SidebarItemStub, SidebarSection, Stub, VStack } from '@direct-frontend/components';
import styles from './SettingsNavMenu.module.css';

export const SettingsNavMenuStub = () => (
    <VStack className={styles.root}>
        <VStack className={styles.title}>
            <Stub height={18} />
        </VStack>

        <SidebarSection>
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />

            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />

            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
        </SidebarSection>
    </VStack>
);
